import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Tooltip } from '@mui/material';
import { AccessTypeT } from 'business/definitions';

const AccessTypeCellRenderer: React.FC<
    CellRendererParams<AccessTypeT | undefined>
> = ({ value }) => {
    const { t } = useTranslation();
    const getIcon = (v?: AccessTypeT | null): React.ReactElement => {
        switch (v) {
            case 'full_access':
                return <DoneRoundedIcon sx={{ color: 'green' }} />;
            case 'restricted':
                return <LockOutlinedIcon sx={{ color: 'orange' }} />;
            default:
                return <CloseRoundedIcon sx={{ color: 'grey' }} />;
        }
    };
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Tooltip
                title={t(`adminSpace.permissionsPanel.${value ?? 'no_access'}`)}
            >
                {getIcon(value)}
            </Tooltip>
        </Box>
    );
};

export default AccessTypeCellRenderer;
